import { css, Theme } from '@emotion/react'

export const checkboxWrapper = (theme: Theme) => css`
  margin-bottom: ${theme.spacing(2)};
`
